import { render, staticRenderFns } from "./daySpecial.vue?vue&type=template&id=089e2272&scoped=true&"
import script from "./daySpecial.vue?vue&type=script&lang=js&"
export * from "./daySpecial.vue?vue&type=script&lang=js&"
import style0 from "./daySpecial.vue?vue&type=style&index=0&id=089e2272&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e2272",
  null
  
)

export default component.exports